document.addEventListener('DOMContentLoaded', function () {

  const faqRoot = document.querySelector('[data-faq]');
  if (!faqRoot) return;

  const items = faqRoot.querySelectorAll('.faq_item');

  items.forEach(function(item) {

    const button = item.querySelector('.faq_q');
    const answer = item.querySelector('.faq_a');

    if (!button || !answer) return;

    answer.style.display = 'none';

    button.addEventListener('click', function() {

      const isOpen = item.classList.contains('is-open');

      items.forEach(function(i) {
        i.classList.remove('is-open');
        const a = i.querySelector('.faq_a');
        if (a) a.style.display = 'none';
      });

      if (!isOpen) {
        item.classList.add('is-open');
        answer.style.display = 'block';
      }

    });

  });

});